<template lang="pug">
  div
    el-row(type="flex" justify="end")
      el-button.create-button(type="primary" @click="openCreateDialog") {{ $t('Members.new') }}
    .content(v-loading="isLoading")
      el-table.group(v-if="ownerAndManagers" :data="ownerAndManagers" cell-class-name="el-table-cell" row-class-name="el-table-row")
        el-table-column(prop="name" :label="$t('Members.name')" sortable="")
          template(slot-scope="props")
            span {{ props.row.name }}
            span.me(v-if="props.row.id == user.id") {{ $t('Members.itsyou') }}
        el-table-column(prop="email" :label="$t('Members.email')" sortable="")
        el-table-column(prop="notes" :label="$t('Members.note')" width="300px")
        el-table-column(width="100px")
          template(slot-scope="props")
            router-link(:to="{name:'member', params:{id:props.row.id}}")
              i.setting.el-icon-setting
              | {{ $t('Members.detail') }}

    //- 管理者追加ダイアログ
    el-dialog(:title="$t('Members.new')" :visible.sync="isShowingDialog" @closed="closedDialog")
      el-form(label-position="left" :rules="rules" label-width="150px" ref="dialogForm" :model="dialogForm" v-loading="isLoading")
        el-form-item(:label="$t('Members.name')" prop="name")
          el-input(v-model="dialogForm.name")
        el-form-item(:label="$t('Members.email')" prop="email")
          el-input(v-model="dialogForm.email")
      span.dialog-footer(slot="footer")
        el-button(@click="closeDialog" :disabled="isLoading") {{ $t('Members.cancel') }}
        el-button(type="primary" @click="sendManagerRequest" :disabled="isLoading") {{ $t('Members.create') }}
</template>

<script>
import UserApi from '@/api/user'
export default {
  data () {
    return {
      isLoading: false,
      isShowingDialog: false,
      ownerAndManagers: [],
      user: null,
      dialogForm: {
        name: '',
        email: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('user.validation_name'), trigger: 'blur' }
        ],
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t('user.validation_email'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  title() {
    return this.$t('submenus.member')
  },
  mounted() {
    this.getOwnerAndManagers();
  },
  methods: {

    getOwnerAndManagers: function (){
      this.isLoading = true;
      const that = this;
      Promise.all([UserApi.getUser(), UserApi.getManagers()])
        .then((values) => {
          that.user = values[0];
          that.ownerAndManagers = values[1];
          that.ownerAndManagers.unshift(that.user);
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('user.failed_get'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },

    // 管理者作成依頼メールの送信
    sendManagerRequest: function() {
      const that = this;
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          that.isLoading = true;
          UserApi.sendManagerRequest(that.dialogForm.name, that.dialogForm.email)
            .then(function() {
              that.isShowingDialog = false;
              that.$message({
                showClose: true,
                message: that.$t('user.success_send_request_mail'),
                type: 'success'
              })
            })
            .catch((error) => {
              that.$message({
                showClose: true,
                message: that.$t('user.failed_send_request_mail'),
                type: 'error'
              });
            })
            .finally(() => { that.isLoading = false; });
        } else {
          return false
        }
      });
    },

    // メンバー作成ダイアログを開く
    openCreateDialog: function() {
      this.isShowingDialog = true
    },

    // メンバー作成ダイアログを閉じる
    closeDialog: function() {
      this.isShowingDialog = false
    },

    // メンバー作成ダイアログを閉じた後の処理
    closedDialog: function() {
      this.$refs['dialogForm'].resetFields();
      this.dialogForm.name = ''
      this.dialogForm.email = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";
@import "../../styles/table-layout.scss";

i.setting {
  margin-right: 3px;
}

a {
  transition: all .3s ease-in-out;
  color: #666;
  &:hover {
    color: $safe;
  }
}

span.me {
  background: $border;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 5px;
}

.create-button {
  margin: 20px 40px -20px;
}

</style>